(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/play_desktop.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/play_desktop.js'); 'use strict';

var tabs = svs.tipset.data.tabs;
var _svs$tipset$tipssm = svs.tipset.tipssm,
    render = _svs$tipset$tipssm.render,
    getContainer = _svs$tipset$tipssm.getContainer;
var roles = svs.core.userSession.roles;
svs.tipset.views.Play = Backbone.Marionette.View.extend({
  regions: {
    couponColumn: '#couponColumn',
    singlerows: '#single-rows',
    statContainer: '#statContainer',
    game: '#game'
  },
  hasCheckedIfMarketPlace: false,
  hasMarketPlaceLoaded: false,
  modelEvents: {
    changeSingleRows: 'toggleSingleRows'
  },
  template: function template(data) {
    return svs.tipset.templates.empty(data);
  },
  initialize: function initialize() {
    $('body').removeClass('bg-oddset-500 bg-stryktipset-500 bg-europatipset-500 bg-extratipset-500 bg-topptipset-200');
  },
  toggleSingleRows: function toggleSingleRows() {
    var _this = this;

    if (!this.hasCheckedIfMarketPlace) {
      var self = this;
      this.setupCoupon = this.setupCoupon.bind(this);

      if (this.shouldInitAccountSelector() && (svs.core.userSession.hasRole(roles.PLAYER) || svs.core.userSession.hasRole(roles.RETAILER))) {
        svs.core.module.load('/cl/marketplace/react:account-selector', null, function () {
          _this.hasCheckedIfMarketPlace = true;
          self.hasMarketPlaceLoaded = true;
          self.setupCoupon();
        });
      } else {
        this.hasCheckedIfMarketPlace = true;
        this.setupCoupon();
      }
    } else {
      this.setupCoupon();
    }
  },
  onAttach: function onAttach() {
    var _this2 = this;

    $('body').removeClass("start-page-".concat(svs.tipset.models.gameDefinitions.get('htmlClass'))).addClass('bg-grey-200');

    if (svs.tipset.collections.draws && svs.tipset.collections.draws.any()) {
      this.model.getDataFromLocalStorage();
    } else {
      var productBase = new svs.components.ProductBase({
        generalSettings: {
          branding: svs.tipset.data.gameDefinitions.htmlClass
        },
        content: {
          gameColumn: {
            view: new svs.tipset.views.SkeletonCoupon()
          }
        },
        tabs: tabs
      });
      productBase.on('tabChanged', function (tabIndex) {
        if (tabs[tabIndex].anchor === 'tips-sm') {
          render();
        } else {
          if (tabs[tabIndex].anchor === 'spelanalys') {
            svs.tipset.gameAnalyzes.renderGameAnalyzes();
          } 


          if (window.ReactDOM && getContainer()) {
            ReactDOM.unmountComponentAtNode(getContainer());
          }
        }
      });
      this.getRegion('game').show(productBase);

      if (window.location.search.indexOf('tips-sm') > -1) {
        render();
      } else if (window.location.search.indexOf('spelanalys') > -1) {
        svs.tipset.gameAnalyzes.renderGameAnalyzes();
      }
    }

    if (!svs.tipset.multiSwiper) {
      this.initMultiSwiper();
    }

    svs.tipset.multiSwiper.updateSize();

    if (svs.core.detect.feature('ft-betslip')) {
      setTimeout(function () {
        svs.core.deviceSession.get('hadShownNewBetslipDialog', 'betslip', function (res) {
          if (res === undefined || res === false) {
            svs.core.deviceSession.set('hadShownNewBetslipDialog', 'betslip', true);

            _this2.showDialog();
          }
        });
      }, 2000);
    }
  },
  showDialog: function showDialog() {
    var target = $('.slip-summary-left-holder'),
        options = {
      content: '<div class="f-center" style="white-space:nowrap;">Betalningen har flyttat ner i kupongen!</div>',
      position: 'top',
      branding: 'popover-black',
      closeOnOutsideClick: true,
      offset: {
        bottom: 0
      }
    },
        popover = new svs.components.Popover(target, options);
    popover.init();
    popover.obj.addClass('animate-show animate-time-2ms');
    popover.obj.on('click', function () {
      popover.hide();
    });
    popover.show();
    popover.obj.css({
      marginLeft: popover.obj.outerWidth() / 2 * -1,
      left: '50%'
    });
    setTimeout(function () {
      svs.components.animation.add(popover.obj, 'animate-hide animate-time-2ms', function () {
        popover.hide();
      });
    }, 8000);
  },
  relativeBetslipSetup: function relativeBetslipSetup() {
    var _this3 = this;

    var isSingleRowMode = this.model.get('isSingleRow');
    var self = this;
    svs.tipset.views.betslip.getRegion('betslipFooter').show(new svs.tipset.views.BetslipFooter({
      model: svs.tipset.models.betslipFooter
    }));
    svs.tipset.views.betslip.getRegion('betslipPayOptions').show(new svs.tipset.views.BetslipPayOptions({
      model: svs.tipset.models.betslipExpanded
    }));
    svs.tipset.views.betslip.getRegion('betslipPay').show(new svs.tipset.views.PayFooter({
      model: svs.tipset.models.betslipFooter
    }));

    if (!isSingleRowMode) {
      this.triggerScroll = function () {
        $('.js-swiper-container').has('#coupon').trigger('scroll');
        setTimeout(function () {
          svs.tipset.views.betslip.setWidth();
        }, 300);
      };

      this.triggerScroll = this.triggerScroll.bind(this);
      this.cancelDebounce = false;
      this.runBetslip = _.debounce(function () {
        if (!self.cancelDebounce) {
          svs.tipset.views.betslip.initRelativeBetslip();
          svs.tipset.views.betslip.betslipStickyBehaviour();

          _this3.triggerScroll();
        }
      }, 500);
      $(window).on('resize', this.runBetslip);
      $(window).on('resizeMultiSwiper', this.runBetslip);
      svs.tipset.models.statistics.on('statisticsSet', this.triggerScroll);
      svs.tipset.collections.matchlist.on('resetAll', this.triggerScroll);
      $('.draw-selector-header').on('click', this.triggerScroll);

      if (svs.tipset.views.actionbar) {
        svs.tipset.views.actionbar.on('showActionbarXpert', svs.tipset.views.betslip.betslipStickyBehaviour, svs.tipset.views.betslip);
      }

      svs.tipset.views.betslip.initRelativeBetslip();
      setTimeout(function () {
        svs.tipset.views.betslip.betslipStickyBehaviour();
        self.model.on('change', svs.tipset.views.betslip.betslipStickyBehaviour, svs.tipset.views.betslip);
      }, 1000);
    }

    if (svs.tipset.models.sportkryss) {
      var sportkryssAmount = svs.tipset.models.sportkryss.get('sportkryssAmount');

      if (sportkryssAmount === '0') {
        $('.sportkryss-container-huxflux').hide();
      }
    }
  },
  shouldInitAccountSelector: function shouldInitAccountSelector() {
    if (this.hasMarketPlaceLoaded) return false;
    return true;
  },
  initAccSelBetslip: function initAccSelBetslip() {
    var _this4 = this;

    var self = this;

    if (svs.utils.ns.isNamespace('svs.components.marketplace.accountSelector.helpers')) {
      svs.components.marketplace.accountSelector.helpers.fetchGames({
        drawNumber: svs.tipset.collections.draws.getCurrentDraw().get('drawNumber'),
        productId: svs.tipset.collections.draws.getCurrentDraw().get('productId')
      }, function () {
        svs.tipset.views.betslip = new svs.app.betslipv2.Betslip(new svs.tipset.controllers.Betslip({
          model: svs.tipset.models.betslipFooter
        }));
        svs.tipset.views.betslip.betslipIsOpen = false;

        if (self.model.get('isSingleRow')) {
          if (!svs.tipset.views.betslip.betslipIsOpen) {
            if (svs.core.detect.feature('ft-betslip')) {
              svs.tipset.views.singleRows.getRegion('betslipRegion').show(svs.tipset.views.betslip);

              if (svs.tipset.models.betslipExpanded && svs.tipset.models.betslipFooter) {
                _this4.relativeBetslipSetup();
              }
            } else {
              svs.tipset.app.getRegion('betslipRegion').show(svs.tipset.views.betslip);
              svs.tipset.views.betslip.getRegion('betslipFooter').show(new svs.tipset.views.BetslipFooterSinglerows({
                model: svs.tipset.models.betslipFooter
              }));
            }
          }
        } else {
          if (!svs.tipset.views.betslip.betslipIsOpen) {
            if (svs.core.detect.feature('ft-betslip')) {
              svs.tipset.views.newCoupon.getRegion('betslipRegion').show(svs.tipset.views.betslip);

              if (svs.tipset.models.betslipExpanded && svs.tipset.models.betslipFooter) {
                _this4.relativeBetslipSetup();
              }
            } else {
              svs.tipset.app.getRegion('betslipRegion').show(svs.tipset.views.betslip);
              svs.tipset.views.betslip.getRegion('betslipFooter').show(new svs.tipset.views.BetslipFooter({
                model: svs.tipset.models.betslipFooter
              }));
            }
          }
        }
      });
    }
  },
  addBetslip: function addBetslip() {
    if (this.model.get('isSingleRow')) {
      svs.tipset.views.betslip = new svs.app.betslipv2.Betslip(new svs.tipset.controllers.Betslip({
        model: svs.tipset.models.betslipFooter
      }));
      svs.tipset.views.betslip.betslipIsOpen = false;

      if (svs.core.detect.feature('ft-betslip')) {
        svs.tipset.views.singleRows.getRegion('betslipRegion').show(svs.tipset.views.betslip);

        if (svs.tipset.models.betslipExpanded && svs.tipset.models.betslipFooter) {
          this.relativeBetslipSetup();
        }
      } else {
        svs.tipset.app.getRegion('betslipRegion').show(svs.tipset.views.betslip);
        svs.tipset.views.betslip.getRegion('betslipFooter').show(new svs.tipset.views.BetslipFooterSinglerows({
          model: svs.tipset.models.betslipFooter
        }));
      }
    } else {
      svs.tipset.views.betslip = new svs.app.betslipv2.Betslip(new svs.tipset.controllers.Betslip({
        model: svs.tipset.models.betslipFooter
      }));
      svs.tipset.views.betslip.betslipIsOpen = false;

      if (svs.core.detect.feature('ft-betslip')) {
        svs.tipset.views.newCoupon.getRegion('betslipRegion').show(svs.tipset.views.betslip);

        if (svs.tipset.models.betslipExpanded && svs.tipset.models.betslipFooter) {
          this.relativeBetslipSetup();
        }
      } else {
        svs.tipset.app.getRegion('betslipRegion').show(svs.tipset.views.betslip);
        svs.tipset.views.betslip.getRegion('betslipFooter').show(new svs.tipset.views.BetslipFooter({
          model: svs.tipset.models.betslipFooter
        }));
      }
    }

    if (this.hasMarketPlaceLoaded) {
      this.initAccSelBetslip();
    }
  },
  addMatchView: function addMatchView() {
    svs.tipset.views.matchview = new svs.tipset.views.MatchView({
      model: new svs.tipset.models.MatchView()
    });
    this.getRegion('statContainer').show(svs.tipset.views.matchview);
    svs.tipset.views.matchview.showBigNav();
  },
  initMultiSwiper: function initMultiSwiper() {
    var multiSwiperOptions = {
      scrollerOptions: [{
        nodeId: 'couponHolder',
        toSubtract: ['#top-content', '#drawChooser']
      }, {
        nodeId: 'statsColumn',
        toSubtract: ['#top-content'],
        noScroller: true
      }]
    };
    svs.tipset.multiSwiper = new svs.components.MultiSwiper(multiSwiperOptions);
    svs.tipset.multiSwiper.init();
  },
  loadAccountSelector: function loadAccountSelector() {
    var self = this;
    this.toggleSingleRows = this.toggleSingleRows.bind(this);

    if (this.shouldInitAccountSelector() && (svs.core.userSession.hasRole(roles.PLAYER) || svs.core.userSession.hasRole(roles.RETAILER))) {
      svs.core.module.load('/cl/marketplace/react:account-selector', null, function () {
        self.setupCoupon();
      });
    } else {
      this.setupCoupon();
    }
  },
  setupCoupon: function setupCoupon() {
    var isSingleRowMode = this.model.get('isSingleRow'),
        drawNumber = svs.tipset.collections.draws && svs.tipset.collections.draws.getCurrentDraw() ? svs.tipset.collections.draws.getCurrentDraw().get('drawNumber') : undefined,
        matchId = svs.tipset.collections.matchlist && svs.tipset.collections.matchlist.getCurrentMatch() ? svs.tipset.collections.matchlist.getCurrentMatch().get('eventNumber').toString() : undefined;

    if (isSingleRowMode) {
      this.getRegion('game').empty();
      svs.tipset.views.singleRows = new svs.tipset.views.SingleRows({
        drawNumber: drawNumber,
        matchId: matchId,
        tab: this.options.tab,
        product: svs.tipset.data.gameDefinitions.htmlClass
      });
      this.getRegion('singlerows').show(svs.tipset.views.singleRows);
      this.$el.toggleClass('single-rows', true);

      if (svs.core.detect.feature('ft-betslip')) {
        svs.isBetslipLoaded = false;
        this.cancelDebounce = true;
        $(window).off('resize', this.runBetslip);
        $(window).off('resizeMultiSwiper', this.runBetslip);
      }
    } else {
      this.getRegion('singlerows').empty();
      svs.tipset.views.newCoupon = new svs.tipset.views.Coupon({
        model: new svs.tipset.models.NewCoupon()
      });
      svs.tipset.views.matchview = new svs.tipset.views.MatchView({
        model: new svs.tipset.models.MatchView()
      });
      var productBase = new svs.components.ProductBase({
        generalSettings: {
          branding: svs.tipset.data.gameDefinitions.htmlClass
        },
        content: {
          gameColumn: {
            view: svs.tipset.views.newCoupon,
            options: {
              multiSwiper: {
                nodeId: 'couponHolder',
                toSubtract: ['#top-content', '.js-product-base-tabs-nav', '#drawChooser']
              }
            }
          },
          contentColumn: {
            view: svs.tipset.views.matchview
          }
        },
        tabs: tabs
      });
      productBase.on('tabChanged', function (tabIndex) {
        if (tabs[tabIndex].anchor === 'tips-sm') {
          render();
        } else {
          if (tabs[tabIndex].anchor === 'spelanalys') {
            svs.tipset.gameAnalyzes.renderGameAnalyzes();
          } 


          if (window.ReactDOM && getContainer()) {
            ReactDOM.unmountComponentAtNode(getContainer());
          }
        }
      });
      this.$el.toggleClass('single-rows', false);
      this.getRegion('game').show(productBase);

      if (window.location.search.indexOf('tips-sm') > -1) {
        render();
      } else if (window.location.search.indexOf('spelanalys') > -1) {
        svs.tipset.gameAnalyzes.renderGameAnalyzes();
      }

      svs.tipset.multiSwiper = productBase.getMultiSwiper();
      svs.tipset.productBase = productBase;
      svs.tipset.views.matchview.showBigNav();
    }

    if (svs.core.detect.feature('ft-betslip')) {
      this.addBetslip();
    } else {
      if (!svs.tipset.views.betslip) {
        this.addBetslip();
      } else {
        svs.tipset.views.betslip.closeBetslip();
      }
    }
  }
});
 })(window);